<template>
  <Content class="col-span-full" :title="$route.name">
    <!-- <Notice class="mb-8">
      {{ $t("HARDWARE_HISTORY_REPORT_NOTE") }}
    </Notice> -->

    <el-form
      status-icon
      :model="ruleForm"
      label-position="top"
      ref="ruleForm"
      label-width="120px"
      class="carpo-form demo-ruleForm"
    >
      <el-form-item
        :label="$t('IMEI')"
        prop="imei"
        v-loading="imeiLoading"
        element-loading-spinner="el-icon-loading"
      >
        <el-select
          @change="imeiUpdate"
          :placeholder="$t('SELECT_PLACEHOLDER')"
          v-model="ruleForm.imei"
          filterable
        >
          <el-option
            v-for="item in imeiList"
            :key="item.id"
            :label="item.imei"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <stopsTable
      class="mt-8"
      :tableData="tableData"
      :loading="tableLoading"
      @setView="setViewIndex = $event"
    />
  </Content>
</template>

<script>
import { imeiList } from '@/api/global'
import stopsTable from '@/components/reports/history/stopsTable.vue'
// import StopsMarkers from "@/components/reports/history/stopsMarkers.vue";
// import customerVehicle from "@/components/reports/history/customerVehicle.vue";
import { stopsHistory } from '@/api/reports'

export default {
  data() {
    return {
      imeiList: [],
      imeiLoading: true,
      tableData: {
        results: [],
      },
      tableLoading: false,
      ruleForm: {
        imei: '',
      },
    }
  },

  components: {
    // Notice,
    stopsTable,
    // customerVehicle,
    // StopsMarkers,
  },
  created() {
    stopsHistory.api().then((res) => {
      if (res) {
        this.tableData = res
      }
    })
    imeiList.api(false).then((res) => {
      if (res) {
        this.imeiList = res
        this.imeiLoading = false
      }
    })
  },
  methods: {
    imeiUpdate() {
      this.tableLoading = true
      this.tableData = {
        results: [],
      }
      stopsHistory.api(this.ruleForm.imei).then((res) => {
        if (res) {
          this.tableLoading = false
          this.tableData = res
        }
      })
    },
  },
}
</script>
